'use client';
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Children, cloneElement, forwardRef, Fragment, isValidElement } from "react";
import { View as RNView, StyleSheet } from "react-native";
/**
 * Wrapper around `react-native` `View` that adds some convenience props for
 * common layout scenarios.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-131}
 */ export var View = /*#__PURE__*/ forwardRef(function(_param, ref) {
    var flex = _param.flex, row = _param.row, style = _param.style, children = _param.children, spacing = _param.spacing, childFlex = _param.childFlex, props = _object_without_properties(_param, [
        "flex",
        "row",
        "style",
        "children",
        "spacing",
        "childFlex"
    ]);
    return /*#__PURE__*/ _jsx(RNView, _object_spread_props(_object_spread({
        ref: ref
    }, props), {
        style: [
            // If the row has childFlex, we're likely trying to align items horizontally to take up the same space
            // In the case of form fields, if one has an error, we want them to align top instead of center
            row ? [
                styles.row,
                childFlex ? {
                    alignItems: 'flex-start'
                } : null
            ] : null,
            flex ? {
                flex: flex
            } : null,
            style
        ],
        children: spacing || typeof childFlex === 'number' ? Children.toArray(children).filter(function(child) {
            return child !== null;
        }).map(function(child, i) {
            return /*#__PURE__*/ _jsxs(Fragment, {
                children: [
                    i > 0 && child ? /*#__PURE__*/ _jsx(RNView, {
                        style: row ? {
                            width: spacing
                        } : {
                            height: spacing
                        }
                    }) : null,
                    typeof childFlex === 'number' && /*#__PURE__*/ isValidElement(child) ? /*#__PURE__*/ cloneElement(child, {
                        // @ts-ignore we pass along style always but aren't actually guaranteed
                        // the children support a style prop
                        style: [
                            child.props.style,
                            {
                                flex: childFlex
                            }
                        ]
                    }) : child
                ]
            }, child ? child.key || i : i);
        }) : children
    }));
});
var styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        alignItems: 'center'
    }
});
